import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import GetAppIcon from "@mui/icons-material/GetApp";
import { FiltroIndicadoresCotizaciones } from "./FiltroIndicadoresCotizaciones";
import { IndicadoresCotizacionesTabla } from "./IndicadoresCotizacionesTabla";
import { IndicadoresCotizacionesCRMService, extraerMensajeError } from "./IndicadoresCotizacionesCRMService";

const MESES_LABEL = [
    "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
    "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE",
];

/**
 * IndicadoresCotizacionesMainScreen
 * Reporte de solo lectura: cotizaciones por semana y línea de negocio durante el mes, contra el
 * objetivo mensual/semanal de cada vendedor. Mismo patrón que IndicadoresVisitasMainScreen
 * (Regresar + Filtro a la izquierda, botón "Excel" a la derecha que descarga
 * IndicadoresCotizaciones/ImprimirExcelReporteCotizaciones con el ejercicio/periodo del filtro
 * actual, título con el periodo consultado). El filtro (Ejercicio/Mes) es la misma réplica que
 * FiltroObjetivosMensuales/FiltroIndicadoresVisitas.
 */
const IndicadoresCotizacionesMainScreen = () => {
    const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });
    const history = useHistory();

    const [filtro, setFiltro] = useState({
        ejercicio: new Date().getFullYear(),
        mes: new Date().getMonth() + 1,
    });
    const [datos, setDatos] = useState([]);

    const cargarReporte = (ejercicio, periodo) => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        IndicadoresCotizacionesCRMService.reporteCotizaciones(ejercicio, periodo)
            .then((result) => {
                setDatos(Array.isArray(result) ? result : []);
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setDatos([]);
                Swal.fire("INDICADORES DE COTIZACIONES", extraerMensajeError(error), "error");
            });
    };

    useEffect(() => {
        cargarReporte(filtro.ejercicio, filtro.mes);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCargar = (ejercicio, mes) => {
        setFiltro({ ejercicio, mes });
        cargarReporte(ejercicio, mes);
    };

    // Descarga el Excel del reporte actual (mismo ejercicio/periodo del filtro) — el backend
    // regresa { documento (base64), filename }, mismo patrón que los demás reportes CRM.
    const onGenerarExcel = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        IndicadoresCotizacionesCRMService.imprimirExcel(filtro.ejercicio, filtro.mes)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = `${filename}.xlsx`;
                downloadLink.click();
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("INDICADORES DE COTIZACIONES", extraerMensajeError(error), "error");
            });
    };

    return (
        <div className="crm-main-screen">
            <LoaderScreen loader={loader} />
            <div className="crm-body">
                <div className="crm-page rca-screen">
                    <div className="crm-module">
                        <div className="crm-module-head">
                            <div className="crm-head-grid">
                                <div className="crm-head-left">
                                    <button className="crm-btn-regresar" onClick={() => history.goBack()} aria-label="Regresar">
                                        <ArrowBackIcon /> <span className="crm-btn-label">Regresar</span>
                                    </button>
                                    <FiltroIndicadoresCotizaciones onCargar={onCargar} ejercicio={filtro.ejercicio} mes={filtro.mes} />
                                </div>
                                <div className="crm-head-center">
                                    <h1 className="crm-module-title">
                                        INDICADORES DE COTIZACIONES - {MESES_LABEL[filtro.mes - 1]} {filtro.ejercicio}
                                    </h1>
                                </div>
                                <div className="crm-head-right">
                                    <button className="crmcs-btn-excel" onClick={onGenerarExcel} aria-label="Excel">
                                        <GetAppIcon /> <span className="crm-btn-label">Excel</span>
                                    </button>
                                </div>
                            </div>
                            <div className="crm-head-divider">
                                <div className="crm-head-divider-dot" />
                            </div>
                        </div>

                        <div className="crm-home-wrapper rca-wrapper scroll">
                            <IndicadoresCotizacionesTabla datos={datos} cargando={loader.mostrar} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IndicadoresCotizacionesMainScreen;
